import { useEffect, useState } from 'react';
import styles from './LayoutEditor.module.css';

export default function SyncProgress() {
  const [startedAt] = useState(() => Date.now());
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setElapsed(Math.max(0, Math.floor((Date.now() - startedAt) / 1000)));
    }, 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  const elapsedLabel = `${Math.floor(elapsed / 60)}:${String(elapsed % 60).padStart(2, '0')}`;

  return (
    <section className={styles.syncProgressBanner} aria-label="Video sync progress">
      <span className={styles.syncSpinner} aria-hidden="true" />
      <div className={styles.syncProgressCopy} role="status" aria-live="polite">
        <div className={styles.syncProgressTitle}>Matching video and telemetry…</div>
        <p>
          {elapsed < 45
            ? 'Finding the timing offset so your overlays line up with the video. This may take a minute or two.'
            : 'Still waiting for the sync result. Your layout changes are kept while detection runs.'}
        </p>
        <p>You can keep arranging overlays. The preview will load automatically when sync is ready.</p>
      </div>
      <span className={styles.syncElapsed} role="timer" aria-live="off" aria-label="Time spent detecting sync">
        {elapsedLabel} elapsed
      </span>
    </section>
  );
}
